import { IHttpApi } from '@cian/http-api';
import { ILogger } from '@cian/logger';
import { IPublicV1BusinessEntityUpdateRequest } from 'shared/repositories/dailyrent/entities/request/PublicV1BusinessEntityUpdateRequest';

import {
  fetchBusinessEntityUpdate,
  TBusinessEntityUpdateRequest,
  TBusinessEntityUpdateResponse,
} from 'shared/repositories/dailyrent/v1/business-entity/update';

import { type Result, Ok, Err } from 'shared/types/result';
import { classifyApiError, IValidationApiError, type IApiError, type TServiceError } from 'shared/utils/apiErrors';

export type TBusinessEntityFieldKey = keyof IPublicV1BusinessEntityUpdateRequest;
export type TBusinessEntityValidationError = IValidationApiError<TBusinessEntityFieldKey>;
export type TUpdateBusinessEntityResult = Result<void, TUpdateBusinessEntityError>;

export type TUpdateBusinessEntityError = TServiceError<TBusinessEntityValidationError, IApiError>;

interface IParams {
  httpApi: IHttpApi;
  parameters: TBusinessEntityUpdateRequest;
  logger: ILogger;
}

export async function updateBusinessEntityData(params: IParams): Promise<TUpdateBusinessEntityResult> {
  const { logger, httpApi, parameters } = params;

  try {
    const { response, statusCode } = (await fetchBusinessEntityUpdate({
      httpApi,
      parameters,
    })) as TBusinessEntityUpdateResponse;

    if (statusCode !== 200) {
      return Err(classifyApiError(response));
    }

    return Ok(response);
  } catch (error) {
    logger.error(error);

    return Err({ type: 'unknown' });
  }
}
